import { ErrorType } from 'types';

import { capitalizeFirstLetter } from 'themes/helpers/capitalizeFirstLetter';

import { Headline } from 'components/Headline';

import * as S from './Label.styles';

type LabelProps = {
  children: string;
  htmlFor: string;
  required?: boolean;
  error?: ErrorType;
};

const defaultProps: Partial<LabelProps> = {
  required: false,
};

export function Label(props: LabelProps): React.ReactElement {
  const { children, required, error, htmlFor } = { ...defaultProps, ...props };

  return (
    <S.Header>
      {children ? (
        <S.Label htmlFor={htmlFor}>{capitalizeFirstLetter(children.toString())}</S.Label>
      ) : null}

      {required ? <Headline color="red">*</Headline> : null}

      {error ? (
        <S.ErrorMessage scale="xs" color="red">
          {error.toString()}
        </S.ErrorMessage>
      ) : null}
    </S.Header>
  );
}
